module.exports = __webpack_public_path__ + "static/media/calendar_icon.d5595487.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calendar_icon.svg
// module id = 135
// module chunks = 0